import React from "react";
import "../styles/Skeleton.css";

const Skeleton = ({ type }) => {
  return (
    <div className={`skeleton-item ${type}`}>
      <div className="shimmer-gradient"></div>
    </div>
  );
};

export default Skeleton;
